import React from 'react';
import { View, Text, Image, StyleSheet, ViewStyle } from 'react-native';
import { Colors, FontWeight } from '../theme/tokens';

interface AvatarProps {
  name?: string;
  initials?: string;
  color?: string;
  url?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  style?: ViewStyle;
}

const SIZES = { xs: 20, sm: 25, md: 38, lg: 50 };

export function Avatar({ name, initials, color, url, size = 'md', style }: AvatarProps) {
  const px = SIZES[size];
  const fontSize = size === 'xs' ? 9 : size === 'sm' ? 10.5 : size === 'lg' ? 17 : 13.5;
  const letters = initials || (name ? name.trim().split(/\s+/).slice(0, 2).map(p => p[0] || '').join('').toUpperCase() : '?');

  return (
    <View style={[
      styles.base,
      { width: px, height: px, borderRadius: px / 2, backgroundColor: color ? undefined : Colors.paper3 },
      style,
    ]}>
      {url ? (
        <Image source={{ uri: url }} style={{ width: px, height: px, borderRadius: px / 2 }} />
      ) : color ? (
        <View style={[styles.gradient, { width: px, height: px, borderRadius: px / 2, backgroundColor: color.startsWith('linear') ? '#6366f1' : color }]}>
          <Text style={[styles.text, { fontSize, color: '#fff' }]}>{letters}</Text>
        </View>
      ) : (
        <Text style={[styles.text, { fontSize }]}>{letters}</Text>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  base: {
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: Colors.line,
    overflow: 'hidden',
    flexShrink: 0,
  },
  gradient: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    fontWeight: FontWeight.semibold,
    color: Colors.ink2,
    textTransform: 'uppercase',
  },
});
